import { render, staticRenderFns } from "./rewardTreasureEditBak.vue?vue&type=template&id=4f461e4a&scoped=true&"
import script from "./rewardTreasureEditBak.vue?vue&type=script&lang=js&"
export * from "./rewardTreasureEditBak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f461e4a",
  null
  
)

export default component.exports